import script from "./videoMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./videoMessage.vue?vue&type=script&setup=true&lang=ts"

import "./videoMessage.vue?vue&type=style&index=0&id=04db7f84&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04db7f84"]])

export default __exports__